<template>
  <div v-if="steps">
    <div class="h-[150px] bg-blue-200 flex items-center font-semibold">
      <div class="gridClass" v-text="steps[currentStep].fullTitle" />
    </div>
    <div class="gridClass flex items-center py-10 bg-white">
      <div class="flex flex-row justify-between w-full">
        <div
          v-for="(step, key) of steps"
          :key="key"
          class="flex-col justify-center items-center text-sm mx-auto"
          :class="[
            currentStep >= key ? '' : ' opacity-60',
            currentStep == key ? 'flex' : 'hidden lg:flex',
          ]"
        >
          <div class="mb-2" v-text="step.title" />
          <div
            v-text="key"
            class="rounded-full aspect-square w-7 flex justify-center items-center"
            :class="
              currentStep >= key
                ? 'text-white bg-blue-600'
                : 'text-black bg-blue-200'
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  currentStep: {
    type: [String, Number],
    required: true,
  },
  steps: {
    type: Object,
    required: true,
  },
});
</script>
